import { render, staticRenderFns } from "./crop-image.vue?vue&type=template&id=2f721dfe&scoped=true"
import script from "./crop-image.vue?vue&type=script&lang=ts"
export * from "./crop-image.vue?vue&type=script&lang=ts"
import style0 from "./crop-image.vue?vue&type=style&index=0&id=2f721dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f721dfe",
  null
  
)

export default component.exports